import { render } from "./MyPublish.vue?vue&type=template&id=f20d8e18&scoped=true"
import script from "./MyPublish.vue?vue&type=script&lang=js"
export * from "./MyPublish.vue?vue&type=script&lang=js"

import "./MyPublish.vue?vue&type=style&index=0&id=f20d8e18&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20d8e18"]])

export default __exports__